import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../util/asyncComponent';
import SalesSupport from './routes/SalesSupport';
import ITSupport from './routes/ITSupport';
import TransportSupport from './routes/TransportSupport';
import Tools from './routes/Tools';


const MasterData = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/sales-support`}/>
            <Route path={`${match.url}/sales-support`} component={SalesSupport}/>
            <Route path={`${match.url}/it-support`} component={ITSupport}/>
            <Route path={`${match.url}/transport-support`} component={TransportSupport}/>
            <Route path={`${match.url}/tools`} component={Tools}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default MasterData;


// WEBPACK FOOTER //
// ./app/routes/MasterData/index.js